var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { TemplateService } from "~/services/domain-service/template.service";
import { Emit, Prop, Watch } from "vue-property-decorator";
import { CommonService } from "~/utils/common.service";
var ModifyMailTemplate = /** @class */ (function (_super) {
    __extends(ModifyMailTemplate, _super);
    function ModifyMailTemplate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messageModel = {};
        _this.rules = {};
        return _this;
    }
    ModifyMailTemplate.prototype.refresh = function () {
        if (!this.data) {
            var templateForm = this.$refs["form"];
            templateForm.resetFields();
        }
        else {
            this.messageModel.templateCode = this.data.templateCode;
            this.messageModel.templateName = this.data.templateName;
            this.messageModel.templateStatus = this.data.templateStatus;
            this.messageModel.isDefault = this.data.isDefault;
            this.messageModel.templateContent = this.data.templateContent;
            this.messageModel.overduePeriod = this.data.overduePeriod;
        }
    };
    ModifyMailTemplate.prototype.close = function () {
        this.messageModel.id = '';
        var modifyForm = this.$refs["form"];
        modifyForm.resetFields();
    };
    ModifyMailTemplate.prototype.emitSuccess = function () {
        this.$message.success("操作成功");
        this.close();
    };
    ModifyMailTemplate.prototype.created = function () {
        this.messageModel = {
            templateCode: "",
            templateName: "",
            templateStatus: "ENABLED",
            templateContent: "",
            templateCategory: "MAIL",
            overduePeriod: "",
            isDefault: "NO",
            id: ''
        };
        this.rules = {
            templateCode: { required: true, message: "请输入模板编号" },
            templateName: { required: true, message: "请输入模板名称" },
        };
    };
    ModifyMailTemplate.prototype.onDataChange = function () {
        if (!this.data)
            return;
        if (!this.data.id)
            return;
        CommonService.revertData(this.messageModel, this.data);
    };
    /**
     * 提交新建模板按钮
     */
    ModifyMailTemplate.prototype.commit = function (type) {
        var _this = this;
        var templateForm = this.$refs["form"];
        templateForm.validate(function (validate) {
            if (!validate)
                return;
            _this.templateService.createTemplate(_this.messageModel).subscribe(_this.emitSuccess);
        });
    };
    __decorate([
        Dependencies(TemplateService)
    ], ModifyMailTemplate.prototype, "templateService", void 0);
    __decorate([
        Prop()
    ], ModifyMailTemplate.prototype, "data", void 0);
    __decorate([
        Emit("close")
    ], ModifyMailTemplate.prototype, "close", null);
    __decorate([
        Emit("success")
    ], ModifyMailTemplate.prototype, "emitSuccess", null);
    __decorate([
        Watch('data', { immediate: true })
    ], ModifyMailTemplate.prototype, "onDataChange", null);
    ModifyMailTemplate = __decorate([
        Component({
            components: {}
        })
    ], ModifyMailTemplate);
    return ModifyMailTemplate;
}(Vue));
export default ModifyMailTemplate;
